import * as swcHelpers from '@swc/helpers';
import { QueryString } from '@grandvisionhq/utils';
import { unwrapResponse } from '../response.js';
import { acceptJson, postJson } from '../shared.js';

const query = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        const category = request && request.categoryType || undefined;
        const expand = request && request.expand ? request.expand.join('|') : undefined;
        const facets = request && request.facets ? request.facets.join('|') : undefined;
        const filters = request && request.filters ? request.filters.join('|') : undefined;
        const pageIndex = request && request.pageIndex || 1;
        const pageSize = request && request.pageSize || 24;
        const sortBy = request && request.sortBy || 'price';
        const sortDirection = request && request.sortDirection || 'asc';
        const queryParams = QueryString.stringify({
            expand,
            filters,
            facets,
            pageIndex,
            pageSize,
            sortBy,
            sortDirection
        }, true, '&', '=', false);
        const endpoint = category ? `/category/${category}/` : '/';
        return unwrapResponse((yield fetch(`${apiUrl}${endpoint}?${queryParams}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson)
        })));
    });
    return function query(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();

export { query };
//# sourceMappingURL=query.js.map
